module.exports = __webpack_public_path__ + "img/page_head.3722e485.png";